import React from "react";

function IndividualSyncDetails() {
  return <div>IndividualSyncDetails</div>;
}

export default IndividualSyncDetails;
